import { useState } from 'react';

const useScheduleTableModals = () => {
  const [modalWindowVisible, setModalWindowVisible] = useState(false);
  const [noPropertiesModalVisible, setNoPropertiesModalVisible] = useState(false);
  const [confirmationModalVisible, setConfirmationModalVisible] = useState(false);

  const handleCloseModal = () => {
    setModalWindowVisible(false);
  };

  const handleCloseNoPropertiesModal = () => {
    setNoPropertiesModalVisible(false);
  };

  const handleOpenConfirmationModal = () => {
    setConfirmationModalVisible(true);
  };

  const handleCancelNotMine = () => {
    setConfirmationModalVisible(false);
  };

  return {
    modalWindowVisible,
    setModalWindowVisible,
    noPropertiesModalVisible,
    setNoPropertiesModalVisible,
    confirmationModalVisible,
    setConfirmationModalVisible,
    handleCloseModal,
    handleCloseNoPropertiesModal,
    handleOpenConfirmationModal,
    handleCancelNotMine,
  };
};

export default useScheduleTableModals;
